<div class="text-center">
  <h3 class="mt-5">{{ title }}</h3>
  <p class="mb-0">{{ info }}</p>
  <a
    routerLink="/page/supported-tokens"
    queryParamsHandling="merge"
    class="btn btn-link"
    i18n="@@fees.pro.fiat.link"
    >See all supported pairs</a
  >

  <div *ngIf="data.discountedFee" class="mt-2">
    <div class="btn-area mb-3">
      <button
        class="btn radio"
        [ngClass]="{ 'btn-primary': !discountedView }"
        (click)="changeTableView(false)"
        i18n="@@feesTable.button.original"
      >
        Original
      </button>
      <div class="p-1"></div>
      <button
        class="btn radio"
        [ngClass]="{ 'btn-primary': discountedView }"
        (click)="changeTableView(true)"
        i18n="@@feesTable.button.discounted"
      >
        Discounted
      </button>
    </div>
    <ng-container *ngIf="discountedView">
      <p class="text-start mb-1">
        <span i18n="@@feesTable.discounted.pairs"
          >The discount applies on the following pairs:
        </span>
        <ng-container *ngIf="!data.discountedFee?.feeDiscountPercent">{{
          data.discountedFee?.pairs | arrayToString
        }}</ng-container>
        <ng-container
          *ngIf="data.discountedFee?.feeDiscountPercent"
          i18n="@@feesTable.discounted.allpairs"
          >All {{ data.fee?.title }}</ng-container
        >
      </p>
      <p class="text-start" i18n="@@feesTable.discounted.pairs.info">
        (For all non mentioned pairs, the original fee table applies)
      </p>
    </ng-container>
  </div>

  <div class="mt-3">
    <ng-container *ngIf="!discountedView || !data.discountedFee">
      <ng-container
        *ngTemplateOutlet="feeTable; context: { fee: data.fee }"
      ></ng-container>
    </ng-container>
    <ng-container *ngIf="discountedView && data.discountedFee">
      <ng-container
        *ngTemplateOutlet="
          feeTable;
          context: { fee: data.discountedFee, discounted: true }
        "
      ></ng-container>
    </ng-container>
  </div>
</div>

<ng-template #feeTable let-fee="fee" let-discounted="discounted">
  <table class="general secondary mb-3" *ngIf="data.last30DaysVolume">
    <tr class="header">
      <th>
        <span *ngIf="fee?.actualFeeStep" i18n="@@fees.pro.table.yourLevel"
          >Your Level</span
        >
        <span *ngIf="!fee?.actualFeeStep" i18n="@@fees.pro.table.fees"
          >Fees</span
        >
      </th>
      <th></th>
      <th></th>
    </tr>
    <tr class="secondary">
      <td>
        <p class="text-bold text-sm" i18n="@@fees.tradeFees.volumeDays">
          30 days Volume
        </p>
        <p>
          {{ data.last30DaysVolume?.amount | customNumber }}
          {{ data.last30DaysVolume?.currency }}
        </p>
      </td>
      <td>
        <p class="text-bold text-sm" i18n="@@fees.tradeFees.makerFee">
          Maker Fee
        </p>
        <p *ngIf="!fee.feeDiscountPercent">
          {{ fee?.actualFeeStep?.makerFee * 100 | number : "0.2-2" }} %
        </p>
        <p *ngIf="fee.feeDiscountPercent">
          <span class="text-linethrough text-gray"
            >{{
              fee?.actualFeeStep?.makerFeeWithoutDiscount * 100
                | number : "0.2-8"
            }}
            %</span
          >
          &nbsp;
          <span class="text-danger"
            >{{ fee?.actualFeeStep?.makerFee * 100 | number : "0.2-8" }} %</span
          >
        </p>
      </td>
      <td>
        <p class="text-bold text-sm" i18n="@@fees.tradeFees.takerFee">
          Taker Fee
        </p>
        <p *ngIf="!fee.feeDiscountPercent">
          {{ fee?.actualFeeStep?.takerFee * 100 | number : "0.2-2" }} %
        </p>
        <p *ngIf="fee.feeDiscountPercent">
          <span class="text-linethrough text-gray"
            >{{
              fee?.actualFeeStep?.takerFeeWithoutDiscount * 100
                | number : "0.2-8"
            }}
            %</span
          >
          &nbsp;
          <span class="text-danger"
            >{{ fee?.actualFeeStep?.takerFee * 100 | number : "0.2-8" }} %</span
          >
        </p>
      </td>
    </tr>
  </table>

  <table class="general table-with-badge">
    <tr class="header">
      <th i18n="@@fees.pro.table.30days">30-Day Volume</th>
      <th i18n="@@fees.pro.table.maker">Maker Fee</th>
      <th i18n="@@fees.pro.table.taker">Taker Fee</th>
    </tr>
    <tr
      *ngFor="let step of fee?.steps"
      [class.highlighted]="
        fee?.actualFeeStep?.fromVolume?.amount === step.fromVolume?.amount
      "
    >
      <td>
        >= {{ step.fromVolume?.amount | customNumber }}
        {{ step?.fromVolume?.currency }}
      </td>
      <td>
        <div *ngIf="!fee.feeDiscountPercent">
          {{ step?.makerFee * 100 | number : "0.2-8" }} %
        </div>
        <div *ngIf="fee.feeDiscountPercent">
          <span class="text-linethrough text-gray"
            >{{
              step?.makerFeeWithoutDiscount * 100 | number : "0.2-8"
            }}
            %</span
          >
          &nbsp;
          <span class="text-danger"
            >{{ step?.makerFee * 100 | number : "0.2-8" }} %</span
          >
        </div>
      </td>
      <td>
        <div *ngIf="!fee.feeDiscountPercent">
          {{ step?.takerFee * 100 | number : "0.2-8" }} %
        </div>
        <div *ngIf="fee.feeDiscountPercent">
          <span class="text-linethrough text-gray"
            >{{
              step?.takerFeeWithoutDiscount * 100 | number : "0.2-8"
            }}
            %</span
          >
          &nbsp;
          <span class="text-danger"
            >{{ step?.takerFee * 100 | number : "0.2-8" }} %</span
          >
        </div>

        <!-- table badge with absolute position; div should located inside td -->
        <div
          *ngIf="discounted"
          class="text-bold"
          [class.table-badge]="discounted"
          i18n="@@fees.content.discounted"
        >
          DISCOUNTED
        </div>
      </td>
    </tr>
  </table>
</ng-template>
